import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";

export type VacuumPolar = {
  do_you_want_to_design_for_external_loads_or_vacuum: PolarYesNoUndefined;
};
type VacuumChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof VacuumPolar }) => void;
  polarQuestions: VacuumPolar;
};
export function VacuumChecks({ onHandleYesNo, polarQuestions }: VacuumChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you want to design for external loads or Vaccum?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "do_you_want_to_design_for_external_loads_or_vacuum" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "do_you_want_to_design_for_external_loads_or_vacuum" });
        }}
        selection={polarQuestions.do_you_want_to_design_for_external_loads_or_vacuum}
      />
    </>
  );
}
